export default "__VITE_ASSET__DXMYfUep__"